export default __webpack_public_path__ + "static/media/Swiss-home-banner-dishwasher-desktop.cc7f87bf.jpg";